export default {
  appName: "GISagro 4.0",
  appTitle: "农地制图管理",
  appSubTitle: "GIS农业服务系统",

  zh:"简体中文",
  a: "",
  an: "",

  about: "关于",
  aboutUs: "关于我们",
  above: "以上",
  accept: "接求",
  account: "账号",
  accountId: "账号",
  address: "地址",
  addressNo: "门牌号",
  addressMoo: "村号",
  addressVill: "村名",
  addressFloor: "楼层",
  addressBuilding: "大楼名",
  alreadyRegistered: "已注册",
  atLeast4Letters: "4-12个字母或数字",
  atLeast6Letters: "6个以上字母或数字",

  systemAdmin: "系統管理",
  admin: "管理",
  administrator: "系統管理员",
  adminOfficialAccount: "公众号管理",
  adminServiceCatalog: "服务类别管理",
  adminTeam: "管理团队",
  adminUser: "管理用户",
  adminOrganization: "管理用户单位",
  adminUserLog: "用户记录",
  adminNews: "发布消息",

  add: "建立",
  addTo: "่添加",
  addToGISagro: "添加到农地图层",
  again: "",
  againZH: "重新",
  ago: "前",
  agree: "同意",
  agreeWith: "接受",
  album: "像册",
  all: "全部",
  alley: "巷",
  allSelected: "已选择全部",
  and: "和",
  andOr: "和/或",
  aor: "负责区",
  area: "地区",
  area2: "面积",
  askFor: "请求",
  assignee: "工作人员",
  assignment: "安排任务",
  asWellAs: "以及",
  attention: "温馨提示",
  atTime: "时间",
  avatar: "个人头像",
  back: "返回",
  background: "背景",
  baseLayers: "基础图层",
  birthday: "生日",
  block: "屏蔽",
  blockedList: "黑名单",
  bounded: "绑定",
  brand: "品牌",
  browse: "查看",
  calculateData: "计算数据",
  camera: "摄像",
  cancel: "取消",
  captcha: "验证码",
  catchword: "流行语",
  category: "求助类别",
  category2: "分类",
  change: "更换",

  channelTypeDirect: "个人",
  channelTypePrivate: "群聊",
  channelTypePublic: "公开",

  chat: "聊聊",
  chats: "聊聊",
  chatUs: "在线咨询",
  chinese: "中文",
  click: "点击",
  clickAt: "点击",
  clickToReadDetails: "点击阅读详情",
  clickToSelectPhoto: "点击图片选择至少已张照片",
  close: "关闭",
  closeJob: "完成",
  code: "码",
  comma: "，",
  comment: "评论",
  conclusion: "总结",
  conditions: "条件",
  confirm: "验证",
  confirmationCode: "验证码",
  contacts: "联系人",
  contactUs: "联系我们",
  contactTypeBlocked: "屏蔽",
  contactTypeGroup: "朋友群",
  contactTypeIndividual: "朋友",
  contactTypeInvited: "新加朋友",
  contactTypeOfficial: "公众服务",
  coordinate: "坐标",
  correction: "改正",
  copyrightHallo: "2017",
  country: "国家",
  countryRegion: "国家/地区",
  county: "县",
  countyName: "县名",
  cubicMeterPerRai: "立方米/莱",
  create: "新建",
  
  crop: "农作物",
  cropRice: "水稻",
  cropMaize: "玉米",
  cropSugarcane: "甘蔗",
  cropCassava: "木薯",

  cassava: "木薯",
  coconut: "椰子",
  coffee: "咖啡",
  durian: "榴莲",
  garden: "混合果园",
  longan: "龙眼",
  maize: "玉米",
  mangosteen: "山竹",
  palm: "棕油",
  pineapple: "菠萝",
  rambuton: "红毛丹",
  rice: "水稻",
  rubber: "橡胶",
  sugarcane: "甘蔗",
  
  daily: "每天",
  dashboard: "图表报告",
  data: "数据",
  dateRange: "申求期间",
  dateTime: "日期和时间",
  dates: "日期",
  day: "日",
  days: "日",
  description: "图片说明",
  details: "详细情况",
  delete: "删除",
  diseaseAndPest: "病情和虫害",
  diseasesAndPests: "农作物病情和虫害",
  displayName: "姓名 / 昵称",
  distance: "距离",
  done: "完成",
  dol: "土地局",
  doubleQuote: "\"",
  download: "下载",
  downloadAsShapeFile: "*.shp 文件",
  downloadAsExcelFile: "*.xlsx 文件",
  downloadPlantData: "%s数据",
  downloadShapeFile: "Shape 文件 (.zip)",
  downloadMapFile: "分府地图 (.pdf)",
  downloadReportFile: "分府报告 (*.xlsx)",
  downloadRIDFile: "分灌溉区报告 (*.xlsx)",
  downloadPlantDisaster: "每周灾情报告 (*.zip)",
  dragAndDropFileHere: "拖放文件 (%s) 到这里",
  dropFileHere: "放文件到这里",
  edit: "编辑",
  email: "邮件",
  emailAddress: "邮箱",
  endDate: "结束日",
  english: "英语",
  enlarge: "放大",
  enter: "输入",
  error: "错误",
  extraInfo: "附加记录",
  failed: "失败",
  farmland: "耕地",
  farmlandShape: "耕地地图 (*.shp)",
  featureInfo: "地图要素信息",
  feedback: "反馈",
  female: "女",
  file: "文件",
  files: "文件",
  fileHasNoData: "空白文件，没有数据内容",
  fileSize: "文件大小",
  filterData: "筛选数据",
  filterMap: "筛选地图",
  followingSettings: "以下设置",
  formula: "配方",
  from: "",
  fromZH: "从",
  fullName: "姓名",
  faq: "常問問題",
  forgot: "忘记",
  friend: "朋友",

  gap: "GAP",
  organicFood: "有机农业",
  rspo: "RSPO",

  gender: "性别",
  general: "通用",
  givenName: "正式名字",
  giveYourComment: "写写你的评论",
  grant: "授权",
  group: "组群",
  growingAreaEvery2Weeks: "卫星图像解译%s种植地",
  growingAreaIn: "%s种植数据",

  administrators: "全权管理员",
  applicationSupports: "管理员",
  executives: "行政主管",
  governors: "主管",
  managers: "经理",
  directors: "厅级",
  divisionManagers: "处级",
  sectionChiefs: "科级",
  teamLeads: "组级",
  teamMembers: "组员",
  operators: "农务员",
  operatorsOthers: "单位人员",
  citizens: "农民",
  businessMen: "商人",
  Specialists: "专家",

  halfYear: "半年",
  hallo: "喂喂",
  halloId: "喂喂号",
  halloUser: "喂喂用户",
  has: "有",
  have: "有",
  haveNo: "没有",
  height: "高度",
  help: "帮助",
  helpManual: "使用手册",
  home: "首页",
  hiUser: "您好! %s",
  hour: "小时",
  hourly: "每小时",
  i: "我",
  iAm: "我是",
  id: "码",
  idCode: "简称",
  if: "如果",
  iKnow: "我知道了",
  image: "图像",
  numberOfImages: "%s 张图像",
  imageArchive: "图像库",
  imageCategory: "图像类别",
  imagingDate: "照相日期",
  implementedDuring: "执行期间",
  implementedBy: "执行人员",
  initials: "简称",
  inRegardTo: "有关事情",
  insert: "添加",
  inService: "已实施",
  inTo: "到",
  invalid: "不正确",
  invalidEmail: "邮箱号不正确",
  invalidMobileNo: "手机号是由0开头组成的10位数",
  invalidSSN: "身份证号不正确",
  invalidUsername: "用户名为 4-12 个字母或数字",
  invalidPassword: "密码至少该有6个字母或数字",
  passwordNotTheSame: "密码不相同",
  irrigationArea: "水利灌溉区",
  is: "是",
  isNot: "不是",
  jobConclusion: "成果总结",
  jobCompletedOn: "完成任务日期和时间",
  jobName: "任务名称",
  openJobPosition: "(空缺)",
  khun: '您',
  ka: "",
  krub: "",
  kilometer: "公里",
  landData: "耕地数据",
  landUploader1: "支持 GPX 和 Shape 文件",
  landUploader2: "Shape 文件包括 *.shp, *.dbf, *.prj 和 *.cpg 文件，这些文件必须打成一个 *.zip 文件包",
  landUploader3: "地图座标是 WGS84 或由 *.prj 文件决定",
  landUploader4: "标准字码是 UTF-8 或由 *.cpg 文件决定",
  landUploader5: "不支持 Complex 和 Multi* 几何",
  landUploader6: "必须包含规定的属性数据，点击这里",
  landUploader7: "下载文件样板",
  landUploaderSupportedFiles: "支持 GPX 和 Shape 文件。Shape 文件包括 *.shp, *.dbf, *.prj 和 *.cpg 文件，这些文件必须打成一个 *.zip 文件包",
  language: "语言",
  lastNDays: "过去%s天",
  lastOneMonth: "过去1个月",
  lastNMonths: "过去%s个月",
  lastOneYear: "过去1年",
  lastNYears: "过去%s年",
  latestUpdate: "更新日期: %s",
  latitude: "纬度",
  latNorth: "北纬",
  latSourth: "南纬",
  layer: "图层",
  layers: "地图图层",
  legend: "图例",
  lte: "不超过",
  gte: "不少于",
  between: "之间",
  livingCountry: "居住国",
  locatedIn: "位于",
  locatePin: "定位",
  location: "位置",
  logAction: "动作",
  login: "登录",
  logining: "正 在 登 录",
  loginWasNotSuccessful: "登录不成功，请查正用户号和密码",
  logout: "退出帐号",
  lonEast: "东经",
  longitude: "经度",
  lonWest: "西经",
  male: "男",
  manage: "执行",
  me: "我",
  measure: "测量",

  messageTypeFile: "文件",
  messageTypeHtml: "链接",
  messageTypeImage: "图像",
  messageTypeLocation: "地点",
  messageTypeSticker: "贴纸",
  messageTypeVideo: "视频",

  menuFile: "文件",
  menuFileNew: "新建文件",
  menuFileLocal: "从自己电脑打开",
  menuFileServer: "从服务器打开",
  menuFileSave: "存储文建",
  menuFileUpload: "上载文建",
  menuFileShare: "分享",
  menuFileDeleteFromServer: "清除文件",
  menuFileProperties: "文件属性",
  menuFilePrint: "打印 ...",
  menuFileSaveAsFile: "截屏",
  menuFileSaveAsPdf: "截屏为PDF文件",
  menuFileSaveAsPng: "截屏为PNG文件",
  
  menuData: "数据",
  menuDataLocal: "从电脑加入数据",
  menuDataServer: "从服务器加入数据",
  menuDataManage: "计算统计",
  menuDataExport: "输出数据",
  menuDataExportZip: "输出为Zip文件",
  menuDataExportExcel: "输出为Excel文件",
  menuDataFilter: "筛选数据",

  menuChart: "图表",
  menuChartTable: "表格",
  menuChartPivot: "Pivot表格",
  menuChartTableSum: "总结表格",
  menuChartBars: "条形图",
  menuChartLines: "线形图",
  menuChartAreas: "面形图",
  menuChartPie: "饼形图",
  menuChartDonut: "圆环图",
  menuChartGauge: "仪表图",
  menuChartComposite: "混合图",
  menuChartScatter: "散布图",
  menuChartBoxPlot: "箱线图",
  menuChartPallel: "平形线图",
  menuChartTreemap: "树状区域图",
  menuChartMap: "地图",

  meter: "米",
  member: "成员",
  mine: "我的",
  minute: "分",
  miss: "小姐",
  mr: "先生",
  mrs: "夫人",
  mobile: "手机",
  mobileNo: "手机号",
  month: "月",
  months: "月",
  monthsText: ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],
  more: "更多...",
  moreThan: "大于",
  multipleSelected: "已选择了一个以上",
  music: "音乐",
  my: "我的",
  nDaysAgo: "%s天前",
  nMonthsAgo: "%s个月前",
  nYearsAgo: "%s年前",
  oneDayAgo: "1天前",
  oneMonthAgo: "1个月前",
  oneYearAgo: "1年前",
  name: "名",
  namePrefix: "尊称",
  nationalId: "身份证号码",
  nationality: "国籍",
  nearTo: "接近",
  new: "新",
  news: "消息",
  newUser: "新用户",
  newJobPosition: "新职位",
  newRequest: "提交求助",
  next: "继续",
  nickname: "昵称",
  night: "夜间",
  no: "不是",
  noData: "没有数据",
  noImage: "没有图像",
  noEmailBounded: "还没绑定电子邮箱",
  noMobileBounded: "还没绑定手机",
  noneSelected: "没有选择",
  not: "未",
  notRegistered: "没有已注册相关资料",
  notSpecify: "不规定",
  notYet: "未",
  notification: "通知",
  notSet: "未设置",
  notSupportedFile: "不支持文件格式: ",
  number: "数码",
  of: "",
  ofAbove: "",
  ofBounded: "",
  officialAccount: "公众号",
  ofPresent: "",
  ofMine: "",
  ofNew: "",
  ofWithin: "内",
  ofYours: "",
  ok: "好的",
  onlineUsers: "在线用户",
  oneMonth: "一个月",
  open: "打开",
  or: "或",
  organization: "工作单位",
  organizationName: "单位名",
  organizationNameIsRequired: "至少要填学单位名，如有地址，也必须选择镇名",
  otpCode: "验证码",
  others: "其它",
  outFrom: "出",
  ownerName: "巴革自治县",
  ownerName0: "技工办工室",
  ownerName1: "泰国暖武里府",
  ownerAddress: "泰国暖武里府巴革自治县巴革镇第一村 Chaengwattana 路一号 电话：(+66) 0-2960-9704~14",

  passportNo: "护照号吗",
  password: "密码",
  permission: "权利",
  personality: "个性风格",
  personInCharge: "负责人",
  phoneCall: "电话",
  photo: "照片",
  place: "地点",
  please: "请",
  preferTo: "我更喜欢",
  preferTH: "",
  present: "当前",
  privacy: "隐私",
  privacyPolicy: "隐私政策",
  private: "不公开",
  privilege: "可使用功能",
  policy: "政策",
  profile: "个人资料",
  province: "省",
  provinceName: "省名",
  public: "公开",
  publish: "公布",
  QRCode: "二维码",
  query: "查询",
  read: "阅读",
  remove: "删除",
  quickGuide: "快速指南",
  reason: "原因",
  refuse: "拒接",
  refuseReason: "拒接原因",
  refuseNotInArea: "不在管理区范围",
  refuseNotPublicProperty: "不是公共财产",
  refuseNotAbleToContactRequester: "无法联系到申求人",
  region: "地区",
  register: "注册",
  registerOrganizations: "单位注册",
  registerUsers: "用户注册",
  registerAnotherUser: "继续注册另一用户?",
  registration: "注册用户",
  reloadMap: "重新下载地图",
  request: "求助",
  requests: "求助",
  requester: "求助人",
  requesterInfo: "求助人资料",
  requestAddComment: "添加评论",
  requestReadAllComments: "查看所有评论",
  requestRecentComments: "最新评论",
  requestServiceLocation: "服务位置",

  requestStatus: "申求่进展",
  requestStatusDraft: "草稿",
  requestStatusSent: "已交送",
  requestStatusNew: "新申求",
  requestStatusReturned: "送回修改",
  requestStatusRefused: "拒接",
  requestStatusAccepted: "已接收",
  requestStatusAssigned : "已分配",
  requestStatusPreparing: "准备中",
  requestStatusImplementing: "工作中",
  requestStatusDone: "已完成",
  requestStatusClosed: "已结束",

  requestTotal: "申求总计",
  requestNew: "新申求",
  requestOverDue: "已超期",
  requestImplementing: "处理中",
  requestCompleted: "已完成",

  requestTableTitleNew: "新申求",
  requestTableTitleOverDue: "已超期申求",
  requestTableTitleImplementing: "正在处理的申求",
  requestTableTitleCompleted: "已完成申求",
  requestTableTitleReceivedInOneMonth: "一个月来收到的申求",

  requestConstruction: "建筑施工",
  requestUrbanPlanning: "城市规划",
  requestCivilWorks: "土木工程",
  requestSanitary: "工共卫生",

  required: "必须填学",
  resendLink: "重发连接",
  responsibleArea: "负责范围",
  responsibleAreaProvince: "负责省",
  responsibleAreaCounty: "负责现",
  responsibleAreaTown: "负责镇",
  return: "送回",
  returnForEdit: "送回改正",
  returnForEditInstruction: "说明须修正内容",
  revoke: "取消",
  revoked: "已取消",

  rAskForService: "申请服务",
  rReport: "报告",
  rMakeComplaint: "投诉",
  rGiveOpinion: "提议",

  reset: "重置",
  result: "工作结果",
  retrieve: "找回",
  ridOffice: "水利管理区",
  ridProject: "水利工程区",
  save: "保存",
  saveAsExcelFile: "保存为 *.xlsx 文件",
  saveDataToDatabase: "保存数据到数据库",
  scanFriendQRCode: "扫扫朋友的二维码",
  scanMe: "扫一扫就可以加我到您的喂喂了",
  scanQRCode: "扫二维码",
  schedule: "日程表",
  search: "查找",
  select: "选择",
  selectAll: "全选",
  selectMeasures: "选择观测类别",
  selectObservedTimeRange: "选择观测期间",
  selectAGpxOrZipFile: "选择一个 %s 或 %s 文件",
  selectArea: "选择地区",
  send: "发送",
  sender: "发送人",
  sendingEmail: "正在送邮件给您，请稍等...",
  sent: "送来",
  service: "相关服务",
  serviceCategory: "服务种类",
  sentViaEmail: "发到邮箱",
  set: "设置",
  seted: "以设置",
  settings: "设置",
  share: "分享",
  show: "显示",
  showOnMap: "显示到地图上",
  shoreLine: "海岸线",
  since: "起算日期",
  size: "大小",
  sms: "短信",
  specify: "说明",
  startDate: "起始日",
  stationAndData: "观测站和数据 %s",
  stationOverview: "观测站总貌",
  street: "街道",
  submit: "提交",
  supervisor: "上司",
  surname: "姓",
  takeNewPhoto: "拍照新像片",
  team: "团队",
  termsAndConditions: "条款和条件",
  test: "测试",
  thai: "泰语",
  then: "然后",
  thungkula: "童库拉隆亥",
  till: "到",
  timeAm: "上午",
  timePm: "下午",
  to: "",
  toTo: "到",
  toClick: "点击",
  today: "今天",
  toSpecify: "设定",
  toSet: "可设置",
  town: "镇",
  townName: "镇名",
  toYou: "",

  unit: "单位",
  unitM: "米",
  unitM2: "平方米",
  unitSQM: "平方米",
  unitKM: "公里",
  unitKM2: "平方公里",
  unitSQKM: "平方公里",
  unitMetric: "米制",
  unitThai: "泰制",
  unitRai: "莱",
  unitNgan: "颜",
  unitWah: "平方瓦",

  until: "直到",
  update: "更改",
  updated: "更新",
  upload: "上载",
  usage: "使用",
  usageCounter: "使用次数累计: %s",
  use: "用",
  user: "用户",
  users: "用户",
  userId: "用户码",
  userName: "用户名",
  userLog: "使用记录",
  userPrivilege: "用户特权",
  userProfile: "用户资料",
  verify: "验证",
  via: "",
  viaZH: "通过",
  videoCall: "视频",
  voice: "录音",
  valid: "正确",
  vsLastMonth: "跟上个月相比",
  waiting: "请稍等...",
  waterResource: "水利资源",
  waterDischargeArea: "排水区",
  watershed: "流域",
  waterUseLayer: "当前需水量",
  week: "星期",
  weekDaysText: ["星期天","星期一","星期二","星期三","星期四","星期五","星期六"],
  welcome: "欢迎",
  welcomeUser: "欢迎! %s",
  width: "宽度",
  within: "",
  wouldLikeTo: "要求",
  year: "年",
  years: "年",
  yearText: "年代",
  yes: "是的",
  yesterday: "昨天",
  you: "您",
  your: "您的",
  zipCode: "邮政编码",

  resetMapRotation: "清除旋转",
  searchLocationOnMap: '搜查位置',
  panMapLeft: "左移",
  panMapRight: "右移",
  panMapUp: "上移",
  panMapDown: "下移",
  fullMapExtent: " 全图",
  zoomIn: "放大",
  zoomOut: "缩小",
  queryMapInfo: "查询地图",
  measureDistance: "量距离",
  measureArea: "量面积",
  measureCoordinate: "量座标",
  printMap: "打印地图",
  changeBasemap: "换底图",
  
  map: "地图",
  mapBase: "地图底图",
  mapBases: "地图底图",

  binding: "绑定", 
  bing: "Bing",
  bingAerial: "影像图",
  bingAerialWithLabels: "影像及标注图",
  bingRoad: "道路图",

  gistda: "GISTDA",
  gistdaGO: "卫星影像图",

  google: "谷哥",
  googleRoad: "街道图",
  googleHybrid: "影像道路混合图",
  googleSatellite: "卫星影像图",
  googleTerrain: "地形图",

  osm: "开放街道地图",
  osmCycleMap: "Cycle",
  osmMapnik: "Mapnik",
  osmOffline: "脱线地图",
  osmTransportMap: "道路交通图",

  userGroup: "用户组群",
  userRegistration: "用户注冊",

  sAboutAlert: "设置在用喂喂聊天时，是否需要声音和振动提示",
  sAboutAllowFindMyRequests: "允许朋友查看全部或仅在指定天数内提交的可公开求助，不公开的求助不能查看",
  sAboutBinding: "绑定这些账号后您就可以方便地用其中之一登陆了",
  sAboutBindingMobile: "绑定后您可用手机号登陆，如果您忘记帐号密码还可同过手机要求系统帮助重新设置",
  sAboutCatchword: "用流行语增添风采提高颜值",
  sAboutClearHalloChannels: "所有个人和群的聊天记录将被清除",
  sAboutEmail: "绑定后您可用邮箱登陆，如果您忘记帐号密码还可要求系统帮助重新设置，另外还可以设置接收重要的系统更新和服务动态消息以便帮助您使用起来更富体验价值",
  sAboutEmailConfirmation: "点击 \"提交\" 后, 我们将送一验证邮件到你所输入的邮箱，请打开并按说明完成剩下步骤",
  sAboutEnableNightMode: "设置是否在晚上接收消息声音和振动提示",
  sAboutLogout: "退出帐号后可以继续查阅时事，但不能申求和聊天",
  sAboutPassword: "设置密码至少要 6 位，而且其中一位必须是大写、小写和数字",
  sAboutShowPreviousText: "打开后，当收到喂喂消息时，荧屏上将显示发信人和内容摘要",
  sAboutUserId: "用户名由 4 到 12 位字母或数字组成，可打小写",
  sAboutUserName: "请设置您的正式姓名，您提交的每份求助将标明您的正式姓名",
  sAboutUserNickname: "朋友圈和聊天信息中显示您的昵称. 选用短、易记且能适当表达你个性风格的名字为好",
  sAcceptThisRequest: "请点击确认是否要接受改申求",
  sAreYouGoingToDeleteSelectedFeatures: "您要删除所选的地图数据是码?",
  sAreYouGoingToDeleteThisItem: "您要删除该数据是码?",
  sAreYouGoingToGrantUserAccount: "您要授使用权给予 %s 是吗?",
  sAreYouGoingToRevokeUserAccount: "您要取消 %s 的使用权是吗?",
  sAtLeast3PointsAreRequired: "至少要选择 3 个点!",
  sActivateAccount: "激活帐号",
  sActivateAccountSuccessful: "您已激活您的帐号，点击下面的 “开始使用” 就可已登陆进入系统了！",
  sStartToUse: "开始使用",

  sButRememberYourHalloId: "可您还记住了您的喂喂码",
  sCancelDraftRequest: "您还没提交该求助，如果取消它将立即消失",
  sCancelRequestEdit: "您已修改过该求助，如果取消所有新信息将立即消失",
  sChangeAccountItIsNotMine: "换个账号吧，上面这个不是我的",
  sChangeEmailSuccessful: "您已成功更新了邮箱，您的新邮箱是 %s",
  sClickMapToMeasure: "点击地图开始测量",
  sConfirmationCodeNotReceiveYet: "还没收到验证码，点击这里",
  sConfirmationCodeSentToSMS: "已通过短信送验证码到您手机去了",
  sConfirmationLinkNotReceiveYet: "还没收到验证邮件，点击这里",
  sConfirmationLinkSentToEmail: "验证邮件已送往您电子邮箱了，请打开邮件并按说明完成剩下步骤",
  sConfirmationEamilRequired: "曾送过验证邮件到您电子邮箱，请打开邮件并按说明完成验证",
  sCanSelectMax7Days: "最多可选择 7 天",
  sDeleteParagraph: "确定要删除此段?",
  sEmailConnectsYouAtAnyPlace: "一个邮箱紧连着你，无论在何时何地",
  sEmailResent: "已重发送验证邮件",
  sEmailVerified: "验证邮件已完成，您已可已登陆",
  sEmailVerificationLinkInvalid: "验证邮件不正确，在以下打入你邮箱后点击 [重送验证邮件给我] 重来已次吧",
  sEnterPresentPassword: "原密码",
  sEnterSignedUpEmail: "输入您在该系统注册的电子邮箱",

  sErrorConnection: "有问题好像您不能联网",
  sErrorUnknown: "我们接到服务器送来的一个没有意料到的问题",

  sForgotPassword: "忘记密码啦！去这里找找看",
  sForgotPasswordSent: "您已成功申请系统产生的随机密码，我们已把它送往您邮箱，谢谢！",
  
  sForLoginAndContact: "以下信息用于用户登陆和系統联系",
  sForUserPermissionAndWorkFlowManagement: "以下信息用于用户权限和工作流程管里",

  sGeneralAutoSavePhoto: "自动保存照片",
  sGeneralAutoSaveVideo: "自动保存录像",
  sGeneralClearChatHistory:"清除聊天记录",
  sGeneralStorage: "存储空间",
  sGeneralTextSize: "文字大小",
  sGeneralTurnOffSpeaker: "关闭声音",

  sInvalidPassword: "密码不符合归定",
  sJustAVisitor: "就随便看看！按这里即可",
  sLoginInvalidAccount: "登陆帐号不对",
  sLoginWithFollowingAccount: "或用以下帐号登陆",
  sLogout: "真的要退出帐号是吗?",
  sMeansYouAgree: "表示您认同",
  sNewMessages: "条新信息",
  sMustSelectAtLeastOnePhoto: "至少要选择一张照片",
  sMustSelectAtLeastOneVideo: "至少要选择一个视频",
  sMustSelectOneCategory: "必须选择一项申求类别",
  sMustSpecifyAllFieldsMarkedWithStar: "输入所有标有星号（*）的资料",
  sMustSpecifyEmailAndOrMobileNo: "必需输入电子邮箱或手机好，最好是输入俩者",
  sNoDataFound: "没有信息",
  sNoDataSelected: "没有选择观测数据",
  sNoPhotoAvailable: "像册里没有照片喔",
  sNotAllowedToDeleteLandWithFarmerSSN: "规定不允许删除已注册农地",
  sNotAllowedToDeleteLandDueTo: "规定不允许删除负责范围内的农地",

  sNotificationEnableAlertSound: "声音",
  sNotificationEnableNightMode: "夜间免打扰",
  sNotificationEnableVibrate: "振动",
  sNotificationMessage: "接收新消息通知",
  sNotificationVideoCall: "接收语音和视频聊天消息通知",
  sNotificationShowPreviewText: "显示聊天消息摘要",

  sNumberOnly: "只需填入数字位",
  sNumberOfPhotoSelected: "所选择照片数量",
  sOpenPasswordResetLinkInEmail: "您可以按照邮件里所介绍步骤重新设置密码",
  sPasswordNotTheSame: "证实密码不对，请重新设置",
  sPasswordReset: "你已重置了密码",
  sPasswordResetLinkSentToEmail: "我们已经把找回密码连接送到你电子邮箱",
  sPasswordResetLinkSentToEmailFailed: "出现错误如下",
  sPasswordResetLinkSentToEmailFailedInstruction: "请纠正错误后重做一次",

  sPrivacyAllowAddMeByContactCard: "可以用名片加我",
  sPrivacyAllowAddMeByGroupChat: "可以从喂喂群加我",
  sPrivacyAllowAddMeByQRCode: "可以用二维码加我",
  sPrivacyAllowFindMeByEmail: "可以用邮箱号找我",
  sPrivacyAllowFindMeByHalloId: "可以用喂喂号找我",
  sPrivacyAllowFindMeByPhone: "可以用手机号找我",
  sPrivacyAllowFindMyRequests: "允许查看我的求助",
  sPrivacyInvitationRequireConfirmation: "加我时需要我先认证",

  sRegisterUser: "还没帐号呢？先申请一个吧",
  sRegistrationLastStepCancel: "注册马上就要成功了，如果现在取消，下次您得从头再来喔",
  sRegistrationName: "快好啦，最后输入你姓名和昵称，另外可点击图片去选择头像",
  sRequestTitleUndefined: "求助标题未定",
  sRequestToAccessAlbum: "喂喂需要浏览你的像册以便显示像片供你选择",
  sResentConfirmationSMS: "重送验证码给我",
  sResentConfirmationEmail: "重送验证邮件给我",
  sResetPasswordViaBoundedEmail: "用绑定邮箱找回密码",
  sResetPasswordViaBoundedMobile: "用绑定手机找回密码",
  sResetPasswordViaAnotherEmail: "用其它邮箱找回密码",
  sResetPasswordViaAnotherMobile: "用其它手机找回密码",
  sSameEmailAsPresentOne: "该邮箱跟您当前注册的一样",
  sScanQRCode: "用音量控制键可以关、闭闪光灯",
  sSelectPhotoFromAlbum: "从像册中选头像",
  sSelectGetInfoToolAndClickonMapToQuery: "选用 GetInfo 工具，然后点击地图以查看位置信系",
  sShare: "选一下要分享到哪？",
  sTakeNewPhoto: "拍照新头像",
  sTapToAddText: "点击添加文字",
  sToChangePassword: "出于安全起见，设置新密吗前请输入原密码",
  sUserLastLogin: "换换，还是用原来的账号好点",
  sWelcomeToHallo: "欢迎加入喂喂！您可以开始使用啦，可您还没设置您的帐号密码喔，最好马上设置",
  sWelcomeToJoin: "欢迎加如我们",
  sWhatsUp: "点击这里设置个性名言",
  sWillSendEmailTitle: "验证电子邮箱",
  sWillSendEmail: "我们将送验证邮件到您以下电子邮箱",
  sWillSendSMSTitle: "验证手机号",
  sWillSendSMS: "我们将送验证码到您以下手机号",
  sWrongPassword: "密码不对，请重新输入。如果忘记密码，可先退出，然后在进入系通页可申求新密吗",
  sCanLoginUsingIdEmailMobileNo: "可以用护照号、邮箱号或手机号登陆",

  //GISagro 4.0
  mapping: "Mapping",
  measuring: "Measuring",
  modeling: "Modelling",
  monitoring: "Monitoring",
  managing: "Managing",
  undo: "Undo",
  redo: "Redo",
  linkData: "互联数据",
  uploadCropData: "上载%s数据",
  uploadGPX: "Upload Data *.gpx|*.shp",
  addPointXY: "Add Point X,Y",
  addPoint: "Add Point",
  addPointAzimuthDistance: "Add Point Azimuth, Distance",
  addPointBearingDistance: "Add Point Bearing, Distance",
  addPointDxDy: "Add Point Dx,Dy",
  addPointA2BDistance: "Add Point A to B",
  dragPoint: "Move Point",
  deletePoint: "Delete Point",
  deletePoints: "Delete Points",
  addPolygonXY: "Add Polygon X,Y",
  addPolygon: "Add Polygon",
  addPolygonTrace: "Add Polygon from Points",
  cutPolygon: "Cut Polygon",
  splitPolygon: "Split Polygon",
  scalePolygonArea: "Scale Polygon",
  transformPolygon: "Transform Polygon",
  modifyPolygon: "Modify Polygon",
  dragPolygon: "Move Polygon",
  indian75ToWgs84: "Transform Indian to WGS84",
  deletePolygon: "Delete Polygon",
  
  //GISagro4.0
  netSpeed: "网络速度",
  adminArea: "行政区",
  dataSource: "数据源",
  cropType: "农作物类别",
  cropFamilies: "科类",
  cropTypes: "属类",
  cropSpecies: "种类",
  deedType: "土地证",
  selectYear: "选择年",
  grow: "种植",
  harvest: "收割",
  growOrHarvestYear: "种植或收割时间",
  searchResult: "搜查结果",

  rice: "水稻",
  maize: "玉米",
  sugarcane: "甘蔗",
  cassava: "木薯",
  
  mlLandMonument: "土地界碑",
  mlFromAllSystems: "DOAE 图层",
  mlFarmland: 'GISagro 耕地',
  mlFarmlandRIPBY: "่今年联结", //"วาดปีงบประมาณ %s",
  mlFarmlandRIBY: "%s年联结",
  mlFarmlandRBBY: "%s年之前联结",
  mlFarmlandR: "已注册",
  mlFarmlandNR: "未注册",

  gBaseMapImagery: "แผนที่ฐาน/ภาพถ่ายดาวเทียม",
  layerGoogleStreetMap: "แผนที่เส้นทางถนนของกูเกิ้ล",
  layerGoogleHybridMap: "แผนที่ภาพของกูเกิ้ล",
  layerSatelliteImageryMunisan: "ภาพถ่ายดาวเทียมเทศบาลนครปากเกร็ด"
};